var isObject = require('../lang/isObject');

/**
 * Adds `value` to the cache.
 *
 * @private
 * @name push
 * @memberOf SetCache
 * @param {*} value The value to cache.
 */
function cachePush(value) {
  var data = this.data;
  if (typeof value == 'string' || isObject(value)) {
    data.set.add(value);
  } else {
    data.hash[value] = true;
  }
}

module.exports = cachePush;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash-compat/internal/cachePush.js
 ** module id = 602
 ** module chunks = 0
 **/